'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactI18next = require('react-i18next');

var _lodash = require('lodash');

var _chemist = require('chemist');

var _Adjustment = require('../Adjustment');

var _Adjustment2 = _interopRequireDefault(_Adjustment);

var _LineItem = require('../LineItem');

var _LineItem2 = _interopRequireDefault(_LineItem);

var _Total = require('../Adjustment/Total');

var _Total2 = _interopRequireDefault(_Total);

var _ExternalLink = require('../ExternalLink');

var _ExternalLink2 = _interopRequireDefault(_ExternalLink);

var _StoreCreditSummary = require('../StoreCreditSummary');

var _StoreCreditSummary2 = _interopRequireDefault(_StoreCreditSummary);

var _FormInput = require('../FormInput');

var _money = require('../../helpers/money');

var Money = _interopRequireWildcard(_money);

var _order = require('../../helpers/order');

var _localisedPaths = require('../../helpers/localisedPaths');

var _flourishStyle = require('./flourishStyle.scss');

var _flourishStyle2 = _interopRequireDefault(_flourishStyle);

var _Form = require('../Form');

var _Form2 = _interopRequireDefault(_Form);

var _AcceptedCardTypes = require('../PaymentOption/AcceptedCardTypes');

var _AcceptedCardTypes2 = _interopRequireDefault(_AcceptedCardTypes);

var _CheckoutContact = require('../../components/CheckoutContact');

var _CheckoutContact2 = _interopRequireDefault(_CheckoutContact);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlourishCartForm = (_dec = (0, _chemist.configurable)(), _dec2 = (0, _reactI18next.translate)(), _dec3 = (0, _reactCssModules2.default)(_flourishStyle2.default, { allowMultiple: true }), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_React$Component) {
  (0, _inherits3.default)(FlourishCartForm, _React$Component);

  function FlourishCartForm() {
    (0, _classCallCheck3.default)(this, FlourishCartForm);
    return (0, _possibleConstructorReturn3.default)(this, (FlourishCartForm.__proto__ || (0, _getPrototypeOf2.default)(FlourishCartForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(FlourishCartForm, [{
    key: 'getTotalForDisplay',
    value: function getTotalForDisplay() {
      var _props = this.props,
          order = _props.order,
          store = _props.config.store;

      var total = parseFloat(order.total);
      if (store.cartTotalIncludesShippingEstimate && parseFloat(order.shipTotal) === 0) {
        var shippingRate = this.findCheapestShippingRate();
        total += shippingRate ? parseFloat(shippingRate.amount) : 0;
      }
      return total;
    }
  }, {
    key: 'promotionTotal',
    value: function promotionTotal(order) {
      return order.adjustments.reduce(function (total, adjustment) {
        return adjustment.promotionCode ? total + parseFloat(adjustment.amount) * -1 : total;
      }, 0);
    }
  }, {
    key: 'findCheapestShippingRate',
    value: function findCheapestShippingRate() {
      var shippingMethods = this.props.order.shippingMethods;
      if (!shippingMethods) return null;

      var lowest = shippingMethods.shippingRates.sort(function (a, b) {
        return parseFloat(a.amount) - parseFloat(b.amount);
      });

      return lowest[0];
    }
  }, {
    key: 'renderEstimatedShippingCost',
    value: function renderEstimatedShippingCost(rate) {
      var t = this.props.t;


      if (rate > 0) {
        return _react2.default.createElement(_reactI18next.Interpolate, {
          i18nKey: 'spree.shipping_from_amount',
          amount: Money.format(rate, this.props.order.currency, this.props.config.store)
        });
      }

      return t('spree.free');
    }
  }, {
    key: 'renderPromotion',
    value: function renderPromotion(promotionTotal) {
      var t = this.props.t;

      if (!promotionTotal) {
        return '';
      }

      var amount = Money.format(promotionTotal, this.props.order.currency, this.props.config.store);

      return _react2.default.createElement(
        'li',
        null,
        _react2.default.createElement(_Adjustment2.default, {
          title: t('discount'),
          amount: '-' + amount
        })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _context,
          _this2 = this;

      var _props2 = this.props,
          t = _props2.t,
          config = _props2.config;

      var promotionTotal = this.promotionTotal(this.props.order);
      var shippingRate = this.findCheapestShippingRate();
      var lng = this.props.params.lng;
      var theme = config.theme,
          store = config.store;


      return _react2.default.createElement(
        _Form2.default,
        {
          action: (0, _localisedPaths.localisedAction)(this.props.config.store, 'cart', lng),
          onSubmit: (_context = this.props).onSubmit.bind(_context),
          method: 'post',
          className: 'row'
        },
        _react2.default.createElement(
          'div',
          { styleName: 'm-orderForm', className: 'col-md-12' },
          _react2.default.createElement(
            'div',
            { styleName: 'm-orderForm--actions-top' },
            _react2.default.createElement(
              _FormInput.Button,
              null,
              t('spree.proceed_to_checkout')
            )
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'm-orderForm__headings', className: 'clearfix' },
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--color' },
              t('spree.cart_form_header.colour')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--product' },
              t('spree.cart_form_header.product')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--quantity' },
              t('spree.quantity')
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'a-orderForm__heading a-orderForm__heading--price' },
              t('spree.price')
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            this.props.order.lineItems.map(function (lineItem, index) {
              var _context2;

              return _react2.default.createElement(_LineItem2.default, (0, _extends3.default)({}, lineItem, {
                index: index,
                key: lineItem.id,
                inputType: _this2.props.cart[lineItem.id.toString()],
                onChangeQuantity: (_context2 = _this2.props).onChange.bind(_context2),
                onClickRemove: (_context2 = _this2.props).onRemove.bind(_context2),
                params: _this2.props.params,
                currency: _this2.props.order.currency,
                errorMessage: _this2.props.lineItemErrors && _this2.props.lineItemErrors[lineItem.id]
              }));
            })
          ),
          _react2.default.createElement(
            'ul',
            { styleName: 'orderTotals' },
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_Adjustment2.default, {
                title: t('spree.subtotal'),
                amount: Money.format(this.props.order.itemTotal, this.props.order.currency, this.props.config.store)
              })
            ),
            this.renderPromotion(promotionTotal),
            (0, _order.automaticPromotions)(this.props.order.adjustments).map(function (adjustment) {
              return _react2.default.createElement(
                'li',
                { key: (0, _lodash.uniqueId)() },
                _react2.default.createElement(_Adjustment2.default, {
                  title: adjustment.label,
                  amount: '-' + Money.format(Math.abs(adjustment.amount), _this2.props.order.currency, _this2.props.config.store)
                })
              );
            }),
            shippingRate && _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_Adjustment2.default, {
                title: t('spree.estimated_delivery_cost'),
                information: shippingRate.description,
                amount: this.renderEstimatedShippingCost(shippingRate.amount)
              })
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(_Total2.default, {
                title: t('spree.shopping_total'),
                information: t('spree.tax_included'),
                amount: Money.format(this.getTotalForDisplay(), this.props.order.currency, this.props.config.store)
              })
            )
          ),
          config.store.displayPromotionInformationLine && _react2.default.createElement(
            'p',
            null,
            t('spree.promotion_info')
          ),
          _react2.default.createElement(
            'div',
            { styleName: 'formActions' },
            _react2.default.createElement(
              _StoreCreditSummary2.default,
              { user: this.props.user },
              _react2.default.createElement(_ExternalLink2.default, {
                href: (0, _localisedPaths.localisedPath)(this.props.config.store, 'productsPath', lng),
                text: t('spree.continue_shopping')
              })
            ),
            this.props.config.store.displayCheckoutContactInfo && _react2.default.createElement(_CheckoutContact2.default, null),
            _react2.default.createElement(
              _FormInput.Button,
              null,
              t('spree.proceed_to_checkout')
            ),
            theme === 'woodcare' && store.acceptedCardTypes.length > 0 && _react2.default.createElement(_AcceptedCardTypes2.default, {
              cardTypes: [].concat((0, _toConsumableArray3.default)(store.acceptedCardTypes), (0, _toConsumableArray3.default)(store.displayAdditionalCardTypes))
            })
          )
        )
      );
    }
  }]);
  return FlourishCartForm;
}(_react2.default.Component), _class2.propTypes = {
  order: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object.isRequired
}, _class2.defaultProps = {
  amount: false
}, _temp)) || _class) || _class) || _class);
exports.default = FlourishCartForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/components/CartForm/flourish.js
// module id = 2446
// module chunks = 0